import {AccessMonitoringApp} from "./Functionality/AccessMonitoringApp";
import HeadTittle from "../../../../components/HeadTittle";
import {IconLeftArrow} from "../../../../components/buttons/IconButtons";
import routes from "../../../../Routes/routes";
import {Box} from "@mui/material";
import ConnectionStatus from "../../DeliveredServices/SubComponents/ConnectionStatus";
import DivContainerBody from "../../../../components/DivContainerBody";
import React from "react";
import {CustomSelect} from "../../../../components/CustomSelect";
import CustomSearch from "../../../../components/SearchSimples/CustomSearch";
import {CustomCompactTable} from "../../../../components/CustomCompactTable";
import AccessDetailsCardModal from "./Modal/AccessDetailsCardModal";
import AccessReportModal from "./Modal/AccessReportModal";
import CustomTablePagination from "../SubComponents/CustomTablePagination";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 08 de 05 de 2026
 */

const AccessMonitoringMain = () => {


    const {
        isOnline,
        setModified,
        item,
        onFilter,
        activeZoneOptions,
        searchText,
        setSearchText,
        handleSearch,
        onReset,
        employees,
        getRowClassName,
        render,
        t,
        setItem,
        showModal,
        setShowModal,
        itemEmployee,
        showReportModal,
        setShowReportModal
    } = AccessMonitoringApp();

    return (
        <>
            <HeadTittle name={'access_monitoring'} IconBack={IconLeftArrow} link={routes.login}>
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>
                    <ConnectionStatus
                        isOnline={isOnline}
                        setModified={setModified}
                        showStatus={true}
                    />
                </Box>
            </HeadTittle>
            <DivContainerBody>
                <div className='row mt-3'>
                    <div className='col-12 col-md-3 px-0 pl-md-1 pr-md-2'>
                        <CustomSelect
                            id={'slt_amm_zone_id'}
                            name={'zoneId'}
                            value={item?.zoneId}
                            keyName='id'
                            onChange={onFilter}
                            list={activeZoneOptions}
                            trans={'zone'}
                            label={'lbl_amm_zone_id'}
                            required={false}
                        />
                    </div>
                    <div className={'col-12 col-md-6 px-0 pl-md-2 pr-md-1'}>
                        <CustomSearch id={'txt_amm_search'}
                                      label={"search_by_name_email_or_phone"}
                                      value={searchText}
                                      setValue={setSearchText}
                                      onChange={(e) => setSearchText(e.target.value)}
                                      searchFunction={handleSearch}
                                      onReset={onReset}
                        />
                    </div>
                    <div className={"col-12 col-md-3"}>
                        <CustomTablePagination
                            rowsPerPage={item?.limit}
                            onRowsPerPageChange={(e) => {
                                setItem((prevData) => ({
                                    ...prevData,
                                    limit: Number(e.target.value),
                                }));
                            }}
                            labelRowsPerPage={t('select_displayed_access')}
                            rowsPerPageOptions={[10,15,20,30,50,100]}
                        />
                    </div>
                </div>
                <div className={"px-1 mb-60px"}>
                    <CustomCompactTable
                        render={render}
                        data={employees?.content || []}
                        searchElement={item?.search}
                        notInformationLegend={t("no_records_available")}
                        getRowClassName={getRowClassName}
                        getRowStatusConfig={(row) => {
                            return row?.success === true
                                ? {
                                    background: 'var(--success-50)',
                                    border: 'var(--success-400)',
                                }
                                : {
                                    background: 'var(--error-code-50)',
                                    border: 'var(--error-code-400)',
                                };
                        }}
                    />
                </div>
            </DivContainerBody>

            <AccessDetailsCardModal
                show={showModal}
                t={t}
                onHide={() => setShowModal(false)}
                data={itemEmployee}
                setModified={setModified}
                setShowReportModal={setShowReportModal}
            />

            <AccessReportModal
                show={showReportModal}
                t={t}
                onHide={() => setShowReportModal(false)}
                data={itemEmployee}
                setModified={setModified}
            />
        </>
    )
}

export default AccessMonitoringMain
